/** Situações da entidade Classificacao */
export interface ClassificacaoSituacao {
    id: number,
    nome: string;
}

export const classificacaoAtiva: ClassificacaoSituacao = {id: 1, nome: 'Ativa'};
export const classificacaoInativa: ClassificacaoSituacao = {id: 2, nome: 'Inativa'};

export const classificacaoSituacoes: ClassificacaoSituacao[] = [
    classificacaoAtiva,
    classificacaoInativa
];

/** Verifica se a situação informada é igual a Ativa */
export function isSituacaoAtiva(situacao: number): boolean {
    if (!situacao) {
        return false;
    }
    return situacao === classificacaoAtiva.id;
}

/** Verifica se a situação informada é igual a Inativa */
export function isSituacaoInativa(situacao: number): boolean {
    if (!situacao) {
        return false;
    }
    return situacao === classificacaoInativa.id;
}
